import React, { useEffect } from "react";
import { ErrorMessage, Field, Form, Formik, useFormik } from "formik";
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from "yup";
import { Translate } from "../../../../language";
import { updateWareHouse, getOneWareHouseById } from "../../../actions/wareHouseActions";


//import React, { useState } from "react";
//import { ErrorMessage, Field, Form, Formik, useFormik } from "formik";
//import * as Yup from "yup";
//import { Translate } from "../../../../language";
///import { UploadImage } from "../../../../components/Register/UploadFile";
import UpdateWarehouseAccountView from "../../../containers/Inventory/Warehause/UpdateWarehouseAccountView";
import { useTokenCallback } from "../../../../utils/hooks/useTokenCallback";
//TodoVictor: Eliminar 

const validationSchema = Yup.object().shape({
    name: Yup.string().required("Es requerido"),
    phone: Yup.string().required("Es requerido"),
    businessCountry: Yup.string().required("Es requerido"),
    businessDepartment: Yup.string().required("Es requerido"),
    businessCity: Yup.string().required("Es requerido"),
    neighborhood: Yup.string().required("Es requerido"),
    businessAddress: Yup.string().required("Es requerido"),
    // picture: Yup.string().required("Es requerido"),


});
export default function UpdateWareHouse({ match,history }) {
    const dispatch = useDispatch()
    const { wareHouse } = useSelector((state) => state.WareHouse);
    let idWarehouse = match.params.idWarehouse
    useTokenCallback(() => {
        dispatch(getOneWareHouseById(idWarehouse))
    }, [idWarehouse])

    //TodoVictor: Incluir UploadImage una vez corregido el servicio 

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: wareHouse?.name || "",
            phone: wareHouse?.phone || "",
            businessCountry: wareHouse?.ubication.businessCountry || "",
            businessDepartment: wareHouse?.ubication.businessDepartment || "",
            businessCity: wareHouse?.ubication.businessCity || "",
            neighborhood: wareHouse?.ubication.neighborhood || "",
            businessAddress: wareHouse?.ubication.businessAddress || "",
            // picture: wareHouse?.profileId.picture.url.small || "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {

            const formData = new FormData();

            for (var key in values) {
                if (key === "picture") {
                    if (values[key]) {
                        formData.append(key, values[key]);
                    }

                } else {
                    formData.append(key, values[key]);
                }

            }

            formData.append("warehouseId", idWarehouse)
            dispatch(updateWareHouse(formData, wareHouse?._id,history))

        }
    })

    return (
        <UpdateWarehouseAccountView wareHouse={wareHouse} formik={formik} isEdit={true} />
    );
}
